import type { EnrollCourse409Result } from './enrollCourse409Result';

export type EnrollCourse409 = {
  /** 에러 코드 */
  errorCode: string;
  /** 실패 사유 */
  reason: string;
  result: EnrollCourse409Result;
};
